import React from "react";
import { XMarkIcon, ClipboardDocumentIcon } from "@heroicons/react/24/outline";

const PopupCopyAddress = ({ data, onClose }) => {
  const copyToClipboard = (value) => {
    navigator.clipboard.writeText(value);
  };
  // console.log(data)

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="w-[90%] max-w-2xl bg-white p-6 rounded-xl shadow-xl relative">
        <button
          onClick={onClose}
          className="absolute text-gray-600 top-2 right-2 hover:text-red-500"
        >
          <XMarkIcon className="w-6 h-6" />
        </button>
        <h2 className="mb-4 text-xl font-semibold text-black">
          Shipping Address
        </h2>
        <div className="space-y-4">
          <div className="flex gap-2">
            <div key="firstName" className="relative w-1/2">
              <label className="block text-sm font-medium text-gray-700 text-start">
                First Name
              </label>
              <input
                type="text"
                value={data.firstName || ""}
                readOnly
                className="w-full px-3 py-2 pr-10 mt-1 text-gray-700 bg-gray-100 border border-gray-300 rounded-md focus:outline-none"
              />
              <button
                onClick={() => copyToClipboard(data.firstName)}
                className="absolute text-gray-500 top-7 right-2 hover:text-blue-600"
                title="Copy"
              >
                <ClipboardDocumentIcon className="w-5 h-5" />
              </button>
            </div>

            <div key="lastName" className="relative w-1/2">
              <label className="block text-sm font-medium text-gray-700 text-start">
                Last Name
              </label>
              <input
                type="text"
                value={data.lastName || ""}
                readOnly
                className="w-full px-3 py-2 pr-10 mt-1 text-gray-700 bg-gray-100 border border-gray-300 rounded-md focus:outline-none"
              />
              <button
                onClick={() => copyToClipboard(data.lastName)}
                className="absolute text-gray-500 top-7 right-2 hover:text-blue-600"
                title="Copy"
              >
                <ClipboardDocumentIcon className="w-5 h-5" />
              </button>
            </div>
          </div>

          <div className="flex gap-2">
            <div key="fullAddress" className="relative w-full">
              <label className="block text-sm font-medium text-gray-700 text-start">
                Full Address
              </label>
              <input
                type="text"
                value={data.fullAddress || ""}
                readOnly
                className="w-full px-3 py-2 pr-10 mt-1 text-gray-700 bg-gray-100 border border-gray-300 rounded-md focus:outline-none"
              />
              <button
                onClick={() => copyToClipboard(data.fullAddress)}
                className="absolute text-gray-500 top-7 right-2 hover:text-blue-600"
                title="Copy"
              >
                <ClipboardDocumentIcon className="w-5 h-5" />
              </button>
            </div>
          </div>

          <div className="flex gap-2">
            <div key="country" className="relative w-1/2">
              <label className="block text-sm font-medium text-gray-700 text-start">
                Country
              </label>
              <input
                type="text"
                value={data.country || ""}
                readOnly
                className="w-full px-3 py-2 pr-10 mt-1 text-gray-700 bg-gray-100 border border-gray-300 rounded-md focus:outline-none"
              />
              <button
                onClick={() => copyToClipboard(data.country)}
                className="absolute text-gray-500 top-7 right-2 hover:text-blue-600"
                title="Copy"
              >
                <ClipboardDocumentIcon className="w-5 h-5" />
              </button>
            </div>
            <div key="city" className="relative w-1/2">
              <label className="block text-sm font-medium text-gray-700 text-start">
                City
              </label>
              <input
                type="text"
                value={data.city || ""}
                readOnly
                className="w-full px-3 py-2 pr-10 mt-1 text-gray-700 bg-gray-100 border border-gray-300 rounded-md focus:outline-none"
              />
              <button
                onClick={() => copyToClipboard(data.city)}
                className="absolute text-gray-500 top-7 right-2 hover:text-blue-600"
                title="Copy"
              >
                <ClipboardDocumentIcon className="w-5 h-5" />
              </button>
            </div>
          </div>

          <div className="flex gap-2">
            <div key="postalCode" className="relative w-1/2">
              <label className="block text-sm font-medium text-gray-700 text-start">
                Postal Code
              </label>
              <input
                type="text"
                value={data.postalCode || ""}
                readOnly
                className="w-full px-3 py-2 pr-10 mt-1 text-gray-700 bg-gray-100 border border-gray-300 rounded-md focus:outline-none"
              />
              <button
                onClick={() => copyToClipboard(data.postalCode)}
                className="absolute text-gray-500 top-7 right-2 hover:text-blue-600"
                title="Copy"
              >
                <ClipboardDocumentIcon className="w-5 h-5" />
              </button>
            </div>
            <div key="state" className="relative w-1/2">
              <label className="block text-sm font-medium text-gray-700 text-start">
                State/Province
              </label>
              <input
                type="text"
                value={data.state || ""}
                readOnly
                className="w-full px-3 py-2 pr-10 mt-1 text-gray-700 bg-gray-100 border border-gray-300 rounded-md focus:outline-none"
              />
              <button
                onClick={() => copyToClipboard(data.state)}
                className="absolute text-gray-500 top-7 right-2 hover:text-blue-600"
                title="Copy"
              >
                <ClipboardDocumentIcon className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupCopyAddress;
